import {
  Box,
  SimpleGrid,
  Image,
  Heading,
  Flex,
  Center,
} from "@chakra-ui/react";
import GithubCalendar from "react-github-calendar";

export default function Github() {
  return (
    <div
      className="w-full  min-h-screen bg-gradient-to-b from-black to-gray-800 p-4 text-white"
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto mt-20 h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Github Calender
          </p>
          <Center mt={50}>
            <GithubCalendar
              username="Gauravshukla82"
              responsive
              global_stats
              tooltips={false}
              summary_text=""
              years_format="YYYY"
              colors={{
                bg: "#ffffff",
                grade4: "#216e39",
                grade3: "#30a14e",
                grade2: "#40c463",
                grade1: "#9be9a8",
                grade0: "#ebedf0",
              }}
            />
          </Center>
        </div>
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Github Stats
          </p>
        </div>
        <div className="flex flex-col justify-center items-center">
          <img
            src="https://github-readme-stats.vercel.app/api?username=Gauravshukla82&hide=stars&count_private=true&show_icons=true&theme=algolia&border_radius=20"
            alt=""
            id="github-stats-card"
            className="m-5"
          />
          <img
            src="https://github-readme-streak-stats.herokuapp.com/?user=gauravshukla82&count_private=true&theme=algolia&border_radius=20"
            id="github-streak-stats"
            alt=""
            className="m-5"
          />
          <img
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=Gauravshukla82&layout=compact&show_icons=true&theme=algolia&border_radius=20"
            alt=""
            id="github-top-langs"
            className="mt-5 mb-20"
          />
        </div>
      </div>
    </div>
  );
}
